var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cities pa-6"},[_c('h4',[_vm._v("Municípios")]),_c('ListCities')],1)}
var staticRenderFns = []

export { render, staticRenderFns }